import React from "react";
import { ProfileComponent } from "../../components/common/ProfileComponent";
import { TableDatabase } from "../../components";
import { RiUserSearchFill } from "react-icons/ri";
import { Spinner } from "react-rainbow-components";
import {
  ComponentGroupButton,
  Container,
  ContainerSearce,
  ContainerTable,
  HeaderContainer,
  HeaderTitle,
  SearchInput,
  TdEmail,
  TdPhone,
} from "./index.style";
import PetBook from "../../assets/icons/PetBook";
import { IPets } from "../../interfaces/pets";
import { IUserDetails } from "../../interfaces/user";
import ModalPets from "../../components/common/ModalPets";
import { getAllUser } from "../../services/user.service";
import { GetErrorMessage } from "../../functions/error";
import { useError } from "../../store/ErrorModal";

const DatabaseCustomerPage = () => {
  const [data, setData] = React.useState<IUserDetails[]>([]);
  const [dataStorage, setDataStorage] = React.useState<IUserDetails[]>([]);
  const [searchKey, setSearchKey] = React.useState<string>("");
  const [isShowModel, setIsShowModel] = React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [dataModal, setDataModal] = React.useState<IPets[]>([]);
  const { onError } = useError();

  const fetchData = React.useCallback(async () => {
    setIsLoading(true);
    try {
      const res = await getAllUser();
      if (!res.data) return onError("มีบางอย่างผิดพลาด");
      setDataStorage(res.data);
      setData(res.data);
    } catch (error) {
      onError(GetErrorMessage(error));
    }
    setIsLoading(false);
  }, [onError]);
  const handleShowModalPets = (pets: IPets[]) => {
    setDataModal(pets);
    setIsShowModel(true);
  };
  React.useEffect(() => {
    fetchData();
  }, [fetchData]);

  React.useEffect(() => {
    if (!dataStorage || dataStorage.length === 0) return;
    const nData = dataStorage.filter((item) => {
      if (
        !item.firstName ||
        !item.lastName ||
        !item.displayName ||
        !item.phone ||
        !item.email ||
        item.petsName === undefined
      )
        return false;
      return (
        item.firstName.includes(searchKey) ||
        item.lastName.includes(searchKey) ||
        item.displayName.includes(searchKey) ||
        item.phone.includes(searchKey) ||
        item.email.includes(searchKey) ||
        item.petsName.includes(searchKey)
      );
    });
    setData(nData);
  }, [searchKey, setSearchKey, dataStorage]);
  const convertData = (dataUsers: IUserDetails[]) =>
    dataUsers.map((item) => [
      ProfileComponent({
        name: `${item.firstName} ${item.lastName}`,
        avatar: item.imageUrl || "",
        lineId: item.petsName && `สัตว์เลี้ยง: ${item.petsName}`,
        style: { minWidth: "280px" },
        styleLineId: { maxWidth: "280px" },
      }),
      <TdPhone>{item.displayName}</TdPhone>,
      <TdPhone>{item.phone}</TdPhone>,
      <TdEmail>{item.email}</TdEmail>,
      <ComponentGroupButton>
        <PetBook
          style={{ cursor: "pointer", marginRight: "0.5rem" }}
          onClick={() => handleShowModalPets(item.pets || [])}
        />
      </ComponentGroupButton>,
    ]);

  return (
    <Container>
      <HeaderContainer>
        <HeaderTitle>
          <RiUserSearchFill size="2rem" />
          <h1>ฐานข้อมูลลูกค้า</h1>
        </HeaderTitle>
        <ContainerSearce>
          <p>ค้นหา</p>
          <SearchInput
            placeholder="ชื่อ / ชื่อไลน์ / เบอร์โทร / สัตว์เลี้ยง"
            onChange={(event) => setSearchKey(event.target.value)}
          />
        </ContainerSearce>
      </HeaderContainer>
      <ContainerTable>
        {isLoading ? (
          <Spinner size="large" variant="brand" />
        ) : (
          <TableDatabase
            header={["ชื่อลูกค้า", "ไลน์", "เบอร์โทร", "อีเมล", "สัตว์เลี้ยง"]}
            tableRows={convertData(data)}
          />
        )}
      </ContainerTable>
      <ModalPets
        isOpen={isShowModel}
        setIsOpen={setIsShowModel}
        data={dataModal}
      />
    </Container>
  );
};

export default DatabaseCustomerPage;
